import React, { Component } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { db } from "../config";
import loader from "../Ellipsis-1s-200px.svg";
import { connect } from "react-redux";
import { getVacancies } from "../actions";
import jobs from '../jobs'

const Table = styled.div`
  display: table;
  width: 100%;
`;
const Row = styled.div`
  display: table-row;
`;
const Cell = styled.div`
  display: table-cell;
  border: 1px solid #f4f4f4;
  padding: 5px;
`;

class Vacancies extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vacancies: this.props.vacancies || []
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    db
      .collection("jobs")
      .get()
      .then(querySnapshot => {
        let vacancies = [];
        querySnapshot.forEach(doc => {
          vacancies.push(doc.data());
          //console.log(doc.data());
        });
        if (vacancies.length) {
          this.props.dispatch(getVacancies(vacancies));
        }
      });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.vacancies !== this.state.vacancies) {
      this.setState({ vacancies: nextProps.vacancies });
    }
  }

  render() {
    const vacancies = this.state.vacancies;
    return (
      <div className="mb4 pa3 mh5-l pb4 bg-white" style={{ overflow: "auto" }}>
        <h1 className="f3 fw5 mb4 mt3">Available Opportunities</h1>
        <VacanciesTable vacancies={jobs} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    vacancies: state.vacancies
  };
};

export default connect(mapStateToProps)(Vacancies);

const VacanciesTable = ({ vacancies }) => (
  <Table>
    <Row className="fw6 tc">
      <Cell>Job Title</Cell>
      <Cell>Job Description</Cell>
      <Cell>Job Requirements</Cell>
      <Cell>Educational Qualification</Cell>
      <Cell>Professional Certification</Cell>
      <Cell>Action</Cell>
    </Row>
    {!vacancies.length ? (
      <img src={loader} height="40" width="40" alt="" />
    ) : (
      vacancies.map((x, i) => (
        <RowWrapper
          key={i}
          id={x.id}
          title={x.title}
          description={x.description}
          requirements={x.requirements}
          certification={x.certification}
          education={x.education}
        />
      ))
    )}
  </Table>
);

const RowWrapper = ({
  title,
  description,
  requirements,
  location,
  closingDate,
  id,
  education,
  certification
}) => (
  <Row>
    <Cell>
      <p style={{ width: 140 }}>{title}</p>
    </Cell>
    <Cell>
      <div
        className="pl4"
        style={{ width: 300, fontSize: 13 }}
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </Cell>
    <Cell>
      <div
        className="pl4"
        style={{ width: 300, fontSize: 13 }}
        dangerouslySetInnerHTML={{ __html: requirements }}
      />
    </Cell>
    <Cell>
      <div
        style={{ width: 180, fontSize: 13 }}
        dangerouslySetInnerHTML={{ __html: education }}
      />
    </Cell>
    <Cell>
      <div
        className="pl3"
        style={{ width: 180, fontSize: 13 }}
        dangerouslySetInnerHTML={{ __html: certification }}
      />
    </Cell>
    <Cell>
      <Link to={`/apply/${id}`} className="underline b blue">
        Apply
      </Link>
    </Cell>
  </Row>
);



// WEBPACK FOOTER //
// ./src/pages/vacancies.js